import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { colors } from '../theme';

import styled from 'styled-components';

import { MenuContents } from './menu-contents-v2';

import { MIN_WIDTH_DESKTOP, MIN_WIDTH_HOMEPAGE_DESKTOP } from '../header-v2';

const Menu = styled.div`
  display: inline;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: none;
  }
`;

export const MenuLink = styled.a`
  display: inline-block;

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: none;
  }
`;

//dropdown nav menu for mobile/tablet
const MobileDropdown = styled.div`
  width: 100%;
  box-shadow: 0 6px 3px -3px rgba(0, 0, 0, 0.02);
  overflow: auto;
  zoom: 1;
  padding: 0 20px;
  transition: max-height 0.2s ease-in-out;
  max-height: ${props => (props.open ? 1000 : 0)}px;

  position: absolute;
  background: #fff;
  right: 0;
  z-index: 4;

  @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
    max-width: 375px;
  }

  @media (min-width: ${props =>
      props.isHomepage ? MIN_WIDTH_HOMEPAGE_DESKTOP : MIN_WIDTH_DESKTOP}) {
    display: none;
  }
`;

const Hamburger = styled.div`
  padding: 26px 20px;
  font-size: 18px;
  color: #888;
  display: inline-block;
`;

const UnreadMessagesCircle = styled.span`
  position: absolute;
  top: 19px;
  width: 13px;
  height: 13px;
  right: 13px;
  display: block;
  margin: 0;
  background-color: ${props => props.theme.danger};
  border: 2px solid ${colors.WHITE};
  border-radius: 100%;
`;

export default class HamburgerMenu extends Component {
  static propTypes = {
    isHomepage: PropTypes.bool,
    loginData: PropTypes.object,
    siteSource: PropTypes.string
  };

  state = {
    isOpen: false,
    location: null
  };

  openMenu = () => {
    this.setState({ isOpen: true });
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;
    const { siteSource, loginData, isHomepage } = this.props;

    return (
      <Menu>
        <MenuLink onClick={isOpen ? this.close : this.openMenu} isHomepage={isHomepage}>
          <Hamburger className="hui-icon-hamburger">
            {loginData && loginData.number_messages > 0 && <UnreadMessagesCircle />}
          </Hamburger>
        </MenuLink>

        <MobileDropdown open={isOpen === true} isHomepage={isHomepage}>
          <MenuContents siteSource={siteSource} loginData={loginData} mobile />
        </MobileDropdown>
      </Menu>
    );
  }
}
